/**
 * 页面的 meta 配置
 */
export var EnumPageMeta;
(function (EnumPageMeta) {
    EnumPageMeta["path"] = "example";
    EnumPageMeta["title"] = "\u793A\u4F8B\u9875\u9762";
    EnumPageMeta["title_en"] = "Example";
})(EnumPageMeta || (EnumPageMeta = {}));
/**
 * 字段描述 枚举
 */
export var EnumLocaleLabel;
(function (EnumLocaleLabel) {
    /** 姓名 */
    EnumLocaleLabel["Name"] = "example.name";
    /** 头像 */
    EnumLocaleLabel["Avatar"] = "example.avatar";
    /** 生日 */
    EnumLocaleLabel["Birthday"] = "example.birthday";
    /** 年龄 */
    EnumLocaleLabel["Age"] = "example.Age";
    /** 性别 */
    EnumLocaleLabel["Gender"] = "example.gender";
    EnumLocaleLabel["Gender_Male"] = "Male";
    EnumLocaleLabel["Gender_Girl"] = "Girl";
    /** 介绍 */
    EnumLocaleLabel["Introduce"] = "example.introduce";
    /** 创建时间 */
    EnumLocaleLabel["CreateDate"] = "example.createDate";
    // 非多语言
    EnumLocaleLabel["Theme"] = "\u4E3B\u9898";
    EnumLocaleLabel["Content"] = "\u5185\u5BB9";
    EnumLocaleLabel["receiverName"] = "\u6536\u4EF6\u4EBA";
    EnumLocaleLabel["receiver"] = "\u6536\u4EF6\u5730\u5740";
    EnumLocaleLabel["emailState"] = "\u53D1\u9001\u72B6\u6001";
    EnumLocaleLabel["UpdateTime"] = "\u6700\u540E\u53D1\u9001\u65F6\u95F4";
    EnumLocaleLabel["emailType"] = "\u901A\u77E5\u65B9\u5F0F";
})(EnumLocaleLabel || (EnumLocaleLabel = {}));
export var EnumGender;
(function (EnumGender) {
    /** 男 */
    EnumGender[EnumGender["Male"] = 1] = "Male";
    /** 女 */
    EnumGender[EnumGender["Girl"] = 2] = "Girl";
})(EnumGender || (EnumGender = {}));
/**
 * 当前页面多语言导出配置
 * 不需要多语言 导出 {en:{},zh:{}} 即可
 */
export default {
    en: {
        [EnumPageMeta.path]: EnumPageMeta.title_en,
        [EnumLocaleLabel.Name]: 'Name',
        [EnumLocaleLabel.Avatar]: 'Avatar',
        [EnumLocaleLabel.Birthday]: 'Birthday',
        [EnumLocaleLabel.Age]: 'Age',
        [EnumLocaleLabel.Gender]: 'Gender',
        [EnumLocaleLabel.Gender_Male]: 'Male',
        [EnumLocaleLabel.Gender_Girl]: 'Girl',
        [EnumLocaleLabel.Introduce]: 'Introduce',
        [EnumLocaleLabel.CreateDate]: 'CreateDate',
    },
    zh: {
        [EnumPageMeta.path]: EnumPageMeta.title,
        [EnumLocaleLabel.Name]: '姓名',
        [EnumLocaleLabel.Avatar]: '头像',
        [EnumLocaleLabel.Birthday]: '生日',
        [EnumLocaleLabel.Age]: '年龄',
        [EnumLocaleLabel.Gender]: '性别',
        [EnumLocaleLabel.Gender_Male]: '男',
        [EnumLocaleLabel.Gender_Girl]: '女',
        [EnumLocaleLabel.Introduce]: '简介',
        [EnumLocaleLabel.CreateDate]: '创建时间',
    },
};
